export default __webpack_public_path__ + "static/media/Logo.e7268888.svg";